import React from "react"
import Specialist from '../../images/description/specialist.png'
import Personal from '../../images/description/personal.png'
import Map from '../../images/description/map.png'


const Description = () => {
    

    return (
        <div className='w-full p-4 md:px-8 lg:px-[60px] lg:justify-between flex flex-col gap-6 lg:flex-row'>
          <img src={Specialist} alt="" className="h-[400px] lg:w-1/3 lg:h-[500px]"/> 
          <img src={Personal} alt="" className="h-[400px] lg:w-1/3 lg:h-[500px]"/> 
          <img src={Map} alt="" className="h-[400px] lg:w-1/3 lg:h-[500px]"/> 
        </div>
    )
}

export default Description